import { BaseService } from "./base.service";

import {
	IMeetingRoom,
	IOrganizationAddress,
} from "models/OrganizationAddressModel";
import { OrganizationAddressDetail } from "models/OrganizationDetail";

class OrganizationAddressServiceInternal extends BaseService {
	getOrganizationAddressList = async (): Promise<IOrganizationAddress[]> =>
		this.callApi<IOrganizationAddress[]>(
			`OrganizationAddress/GetOrganizationAddressList`,
			"GET"
		);

	getMeetingRoomList = async (
		organizationAddressId: number
	): Promise<IMeetingRoom[]> =>
		this.callApi<IMeetingRoom[]>(
			`OrganizationAddressMeetingRoom/GetMeetingRoomList/${organizationAddressId}`,
			"GET"
		);

	getOrganizationAddressGridList = async (): Promise<
		OrganizationAddressDetail[]
	> =>
		this.callApi<OrganizationAddressDetail[]>(
			`OrganizationAddress/GetOrganizationAddressGridList`,
			"GET"
		);

	getOrganizationAddressById = async (
		organizationAddressId: number
	): Promise<OrganizationAddressDetail> =>
		this.callApi<OrganizationAddressDetail>(
			`OrganizationAddress/GetById/${organizationAddressId}`,
			"GET"
		);

	saveOrganizationAddress = async (
		organizationAddressModel: OrganizationAddressDetail
	): Promise<number> =>
		this.callApi<number>(
			`OrganizationAddress/Save`,
			"POST",
			undefined,
			organizationAddressModel
		);

	updateOrganizationAddress = async (
		organizationAddressModel: OrganizationAddressDetail
	): Promise<number> =>
		this.callApi<number>(
			`OrganizationAddress/Update/${organizationAddressModel.organizationAddressId}`,
			"POST",
			undefined,
			organizationAddressModel
		);

	checkOrganizationAddressAlreadyUsed = async (
		organizationAddressId: number
	): Promise<boolean> =>
		this.callApi<boolean>(
			`OrganizationAddress/CheckOrganizationAddressAlreadyUsed/${organizationAddressId}`,
			"GET"
		);

	deleteOrganizationAddress = async (
		organizationAddressId: number
	): Promise<null> =>
		this.callApi<null>(
			`OrganizationAddress/Delete/${organizationAddressId}`,
			"DELETE"
		);
}

export const OrganizationAddressService =
	new OrganizationAddressServiceInternal();
